import { render } from "./BatchesWaitingToReceiveContainer.vue?vue&type=template&id=45d20854"
import script from "./BatchesWaitingToReceiveContainer.vue?vue&type=script&lang=js"
export * from "./BatchesWaitingToReceiveContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__